import React from 'react'
import AddBlogForm from '../../AdminPages/form/addBlogForm'
import Navbar from '../common/navbar'
import Footer from '../common/footer'
import { Paper } from '@mui/material'


function StudentBlogUpload() {

    const [studentId , setStudentId] = React.useState(1);

    // keep it
    function handleClose(){}
    // keep it



    return (
        <>
            <Navbar />
            <div className='container '>
                <Paper className='p-md-3'>
                    <h3>Add Blog</h3>
                    <AddBlogForm type={'student'} handleClose={handleClose} studentId={studentId}/>
                </Paper>
            </div>
            <Footer />
        </>
    )
}

export default StudentBlogUpload